"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var credit_card_icon_1 = require("../credit_cards/legacy/credit_card_icon");
var bind_1 = require("../bind");
function renderCardSummary(creditCard) {
    var cardAbout = creditCard.cardType + " ...." + creditCard.last4;
    var expiryDate = creditCard.expirationMonth + "/" + creditCard.expirationYear;
    return (React.createElement("div", { className: "cc-details__card-info" },
        React.createElement("div", { className: "cc-details__card-type" }, cardAbout),
        React.createElement("div", { className: "cc-details__expiration" }, I18n.t('discovery.selectableCreditCardList.expiresOn', { date: expiryDate }))));
}
var SelectableCreditCardList = /** @class */ (function (_super) {
    tslib_1.__extends(SelectableCreditCardList, _super);
    function SelectableCreditCardList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SelectableCreditCardList.prototype, "topCards", {
        get: function () {
            return this.props.creditCards.slice(0, 5);
        },
        enumerable: true,
        configurable: true
    });
    SelectableCreditCardList.prototype.renderSelectableCards = function () {
        var _this = this;
        return this.topCards.map(function (creditCard, index) {
            return (_this.renderSelectableCard(creditCard, index));
        });
    };
    SelectableCreditCardList.prototype.isChecked = function (creditCard, index) {
        if (this.props.selectedCreditCardId) {
            return creditCard.id === this.props.selectedCreditCardId;
        }
        return index === 0;
    };
    SelectableCreditCardList.prototype.handleEditClick = function (cardId) {
        this.props.handleEditClick(cardId);
    };
    SelectableCreditCardList.prototype.updateSelectedCreditCardId = function (id) {
        this.props.setSelectedCreditCardId(id);
    };
    SelectableCreditCardList.prototype.renderEditLink = function (cardId) {
        var _this = this;
        if (!this.props.showEditURL) {
            return null;
        }
        return (React.createElement("div", null,
            React.createElement("button", { className: "weight-bold f-right button-as-link", type: "button", onClick: function () { _this.handleEditClick(cardId); } }, I18n.t('discovery.selectableCreditCardList.edit'))));
    };
    SelectableCreditCardList.prototype.renderSelectableCard = function (creditCard, index) {
        var _this = this;
        return (React.createElement("li", { className: "shop-onboarding__card", key: creditCard.id, id: "credit_card_" + creditCard.id, onClick: function () { return _this.updateSelectedCreditCardId(creditCard.id); } },
            React.createElement("input", { className: "boxed-list__toggle", type: "radio", checked: this.isChecked(creditCard, index), id: "credit_card_" + creditCard.id, readOnly: true }),
            React.createElement("div", { className: "boxed-list__item boxed-list__item--selectable" },
                React.createElement("div", { className: "cc-details" },
                    React.createElement("div", { className: "cc-details__card" },
                        React.createElement("div", { className: "cc-details__icon" },
                            React.createElement(credit_card_icon_1.default, { cardType: creditCard.cardType })),
                        renderCardSummary(creditCard)),
                    this.renderEditLink(creditCard.id)))));
    };
    SelectableCreditCardList.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("ul", { className: "shop-onboarding__cards" }, this.renderSelectableCards()),
            this.props.children));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SelectableCreditCardList.prototype, "handleEditClick", null);
    tslib_1.__decorate([
        bind_1.default
    ], SelectableCreditCardList.prototype, "updateSelectedCreditCardId", null);
    return SelectableCreditCardList;
}(React.Component));
exports.default = SelectableCreditCardList;
//# sourceMappingURL=selectable_credit_card_list.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/onboarding/selectable_credit_card_list.js
// module id = Tnk1
// module chunks = 20 21